import React, {PureComponent} from 'react';
import Helmet from 'react-helmet';
import {withRouter} from 'react-router-dom';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import {ImageHeader, ImageHeaderTitle} from '../../components/ImageHeader/ImageHeader.jsx';
import ScrollSpy from '../../components/ScrollSpy/ScrollSpy.jsx';
import ScrollSpyWatch from '../../components/ScrollSpy/ScrollSpyWatch.jsx';
import LinkScroll from '../../components/LinkScroll/LinkScroll.jsx';
import MenuCheum from '../../components/MenuCheum/MenuCheum.jsx';

import conf from '../../conf.js';
import scrollToElement from '../../services/scrollTo.js';

import './CGU.scss';

const title = "Conditions générales d'utilisation";
const description = "Les conditions générales d’utilisation et de vente sont conclues entre Twineeds et l'utilisateur";

class CGU extends PureComponent {
  static iTopOffset = conf.topOffset;
  static sTopOffset = CGU.iTopOffset + 'px';

  componentDidMount() {
    scrollToElement(this.props.location.hash);
  }

  render() {
    const helmet = <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:description" content={description}/>
      <meta property="og:title" content={title}/>
    </Helmet>;

    return <DefaultLayout className="cgu" helmet={helmet}>
      <ImageHeader>
        <ImageHeaderTitle>
          <h1>Conditions générales d'utilisation</h1>
        </ImageHeaderTitle>
      </ImageHeader>
      <section id="cgu-body">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="intro">
                <div className="mt-5">
                  <div className="mb-5">
                    <p>
                      Les présentes conditions générales d’utilisation et de vente (ci-après dénommées
                      « Conditions Générales ») sont conclues entre : <br/>
                      La société {conf.site.name.toUpperCase()} SAS, éditeur du site {conf.site.url.name}, Société Par
                      Action Simplifiée au capital de 10 000 euros, immatriculée au RCS de Paris sous le n° 832 390 421
                      et dont le siège social est situé {conf.address.street}, {conf.address.postalCode} {conf.address.locality},
                      (ci-après la « Société » ou « {conf.site.name.toUpperCase()} ») d’une part<br/>
                      Et<br/>
                      L’Utilisateur du Site {conf.site.url.full}
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="general">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="general">Information générales</h2></div>
                  <div className="mb-5">
                    <p>
                      Contact email : {conf.site.emails.contact} <br/>
                      Numéro de téléphone : {conf.site.phone} <br/>
                      Numéro de déclaration simplifiée Cnil : {conf.site.cgu.cnil} <br/>
                      Numéro de TVA intracommunautaire : {conf.site.cgu.tva}
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="hosting">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="hosting">Hébergement</h2></div>
                  <div className="mb-5">
                    <p>
                      OVH<br/>
                      SAS au capital de 10 059 500 €<br/>
                      RCS Lille Métropole 424 761 419 00045<br/>
                      Code APE 6202A<br/>
                      N° TVA : FR 22 424 761 419
                    </p>
                    <p>
                      Siège social :<br/>
                      2 rue Kellermann<br/>
                      59100 Roubaix<br/>
                      France<br/>
                      téléphone : 1007
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="preambule">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="preambule">Préambule</h2></div>
                  <div className="mb-5">
                    <p>
                      La société exploite un site internet accessible à l’adresse {conf.site.url.full} proposant une
                      mise en relation entre des professionnels indépendants (ci-après désigné « consultants ou
                      consultants freelances») réalisant des prestations de conseil et des donneurs d’ordre/clients
                      (ci-après désignés « Donneurs d’Ordre »), également désignés conjointement les « Utilisateurs ».
                    </p>
                    <p>
                      Les présentes Conditions Générales ont pour objet de régir les conditions
                      d’utilisation du Site ainsi que les droits et obligations des Utilisateurs.
                      Tout accès ou utilisation du Site suppose l’acceptation sans réserve et le
                      respect de l’ensemble des Conditions Générales.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="registration">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="registration">Inscription au Site</h2></div>
                  <div className="mb-5">
                    <p>
                      Pour pouvoir accéder aux services proposés par le Site, l’Utilisateur doit
                      créer un compte en s’inscrivant gratuitement sur le Site. L’Utilisateur doit
                      être âgé d’au moins 18 ans et être capable juridiquement de contracter et
                      d’utiliser le Site conformément aux présentes Conditions Générales.
                      L’Utilisateur est tenu de fournir des informations exactes qu’il s’engage
                      à mettre immédiatement à jour en cas de modification.
                    </p>
                    <p>
                      L'Utilisateur devra en outre communiquer à la Société tout document relatif à
                      son identification ou à sa situation vis-à-vis des obligations légales en
                      vigueur sur simple demande et dans un délai de 48 heures.
                    </p>
                    <p>
                      L’accès au compte créé pour l’Utilisateur est protégé par un identifiant et un
                      mot de passe.
                    </p>
                    <p>
                      L’utilisateur est le seul responsable de tout usage qui sera fait de ces deux
                      informations et il est le seul garant de leur confidentialité. L’Utilisateur
                      sera tenu comme seul responsable de toute utilisation de son compte.
                    </p>
                    <p>
                      Dans l'hypothèse où l’Utilisateur fournirait des données fausses, inexactes,
                      périmées ou incomplètes, la Société sera en droit de suspendre ou de procéder
                      à la fermeture de son compte et de lui refuser, à l'avenir, l'accès à tout ou
                      partie des Services.
                    </p>
                    <p>
                      La Société se réserve le droit de refuser toute inscription ou de mettre fin à
                      toute utilisation de compte d’Utilisateur sur simplement notification
                      électronique et sans obligation de motivation.
                    </p>
                  </div>
                </div>
              </ScrollSpy>


              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="services">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="services">Description des Services et fonctionnement du Site</h2>
                  </div>
                  <div className="mb-5">
                    <p>
                      Une fois inscrit, l’Utilisateur peut bénéficier des Services du Site.
                      Ces Services comprennent notamment :
                    </p>
                    <ul>
                      <li>
                        Une mise en relation entre les Consultants et les Donneurs d’Ordre par
                        l’intermédiaire de la Société
                      </li>
                      <li>
                        Une mise à disposition d’outils pour évaluer les compétences des Consultants
                        en vue d’informer les Donneurs d’Ordre
                      </li>
                      <li>
                        Des prestations de conseil pour assister les Donneurs d’Ordre dans la
                        recherche de Consultants pouvant remplir des missions identifiées
                      </li>
                    </ul>
                    <p>
                      Les Consultants ayant remplis leur fiche de renseignement et ayant été acceptés
                      après évaluation de leur dossier par la Société sont inscrits dans une base de
                      donnée anonyme accessible sur le Site. A noter que le tarif journalier indicatif
                      et la disponibilité des Consultants sont donnés sur le Site à titre purement
                      indicatif et ne saurait être considérés comme des engagements ou des obligations
                      de la part des Utilisateurs ou de la Société. En conséquence de quoi les
                      Utilisateurs et la Société se réservent le droit de modifier ces éléments à tout
                      moment sans que cela puisse donner lieu à un quelconque préjudice ni à une
                      quelconque réparation.
                    </p>
                    <p>
                      Les Donneurs d’Ordre peuvent ensuite utiliser les outils de recherche mis à
                      disposition par le Site pour identifier un ou plusieurs Consultants susceptibles
                      d’effectuer une mission pour leur compte. Les Donneurs d’Ordre sollicitent alors
                      le Site ou la Société pour identifier les Consultants concernés et rentrer en
                      relation avec eux. La Société se réserve le droit de donner suite ou non à cette
                      demande.
                    </p>
                    <p>
                      Sous réserve d’engagement des différents Utilisateurs de respecter les conditions
                      financières et opérationnelles de la mise en relation proposées par la Société,
                      le Donneur d’ordre, le consultant et la Société peuvent rentrer en contact en vue
                      d’évoquer les conditions de réalisation d’une mission. En cas d’aboutissement des
                      discussions, la Société signe un contrat avec le consultant d’une part et un
                      contrat avec le Donneur d’Ordre d’autre part en vue de réaliser la mission.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="access">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="access">Accès au Site et aux Services</h2></div>
                  <div className="mb-5">
                    <p>
                      L’accès au Site et aux Services est exclusivement réservé aux Utilisateurs
                      inscrits. Les Utilisateurs font leur affaire personnelle de la mise en place
                      des moyens permettant l’accès au Site. Ils conservent à leur charge les frais
                      de télécommunication lors de l’accès et de l’utilisation du Site. Le Site est
                      accessible 24heures sur 24, 7 jours sur 7 pour l’ensemble des Utilisateurs.
                    </p>
                    <p>
                      La Société se réserve le droit, sans préavis ni indemnité, de fermer
                      temporairement ou définitivement le Site ou l’accès à un ou plusieurs
                      Services pour effectuer des mises à jour ou des modifications techniques.
                      Elle se réserve plus généralement le droit d’apporter au Site et aux Services
                      toutes les modifications et améliorations qu’elle jugera nécessaires ou utiles
                      dans le cadre du bon fonctionnement du Site et de ses Services.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="notation">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="notation">Système d’évaluation et de recommandation</h2></div>
                  <div className="mb-5">
                    <p>
                      {conf.site.name} appliquera son propre système d’évaluation sur la base du CV, des
                      références données par le Consultant et des entretiens de qualification qui pourraient
                      avoir lieu, l’objectif étant de standardiser les niveaux d’expertises dans les
                      différents domaines en dehors de toute appréciation personnelle.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="engagements">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="engagements">Engagements</h2></div>
                  <div className="mb-5">
                    <p>
                      L’Utilisateur s’engage à accéder et à utiliser le Site conformément aux lois et
                      règlements en vigueur et en accord avec les dispositions des présentes Conditions
                      d’Utilisation.
                    </p>
                    <p>
                      L’Utilisateur s’engage notamment à :
                    </p>
                    <p>
                      (1) Satisfaire à toutes les obligations légales et réglementaires<br/>
                      L’Utilisateur, notamment lorsqu’il est consultant, s’engage à accomplir toutes
                      les déclarations et toutes les formalités nécessaires à son activité et à l’utilisation
                      des Services, en matière juridique, sociale, administrative et fiscale notamment. Sur
                      simple demande, l’Utilisateur s’engage à fournir tout document prouvant qu’il remplit
                      toutes les obligations énoncées ci-dessus.
                    </p>
                    <p>
                      (2) S’interdire de contourner la mise en relation proposée par le Site<br/>
                      L’Utilisateur s’interdit (a) de publier ou de communiquer toute information permettant à
                      un autre Utilisateur du Site de rentrer en contact directement avec lui sans passer par
                      l’intermédiaire du Site ou de la Société. Sont en particulier visé par cette disposition
                      toute communication d’adresse email ou de numéro de téléphone de nature à concrétiser
                      un contact direct entre deux Utilisateurs sans passer par l’intermédiaire du Site ou de
                      la Société. L'Utilisateur s'interdit (b) de contractualiser, à titre personnel ou
                      par sa propre société, sans l'intermédiaire de la Société avec un Client final pour
                      le besoin du Client dont il aurait été mis en relation par l'intermédiaire de la Société.
                    </p>
                    <p>
                      (3) Utiliser de manière loyale du Site<br/>
                      L’Utilisateur s’interdit d’utiliser le contenu du site pour mettre en place toute action de
                      promotion commerciale pour son compte ou celui d’un tiers autre que pour les prestations
                      de conseils visées par le Site. L’Utilisateur s’interdit également de constituer des bases
                      de données commerciales à but de démarchage ou d’utiliser les informations collectées sur
                      le site en vue d’établir des études ou en vue de mener des actions de recrutement non
                      autorisées par la Société.
                    </p>
                    <p>
                      L’Utilisateur s’engage à garder une stricte confidentialité aux échanges qu’il aurait eu
                      avec des Clients/Donneurs d’Ordre et aux informations qui lui auraient été transmises ou dont
                      il aurait connaissance à l’occasion d’une mise en contact via le Site (ayant ou non donné
                      lieu à une Mission).
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="responsabiliteu">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="responsabiliteu">Responsabilité de l’Utilisateur</h2></div>
                  <div className="mb-5">
                    <p>
                      L’Utilisateur est seul responsable des informations et contenus qu’il diffuse par le biais
                      du Site, {conf.site.name.toUpperCase()} ne contrôlant pas ces éléments avant mise en ligne.
                      L’Utilisateur est seul
                      responsable des conséquences et préjudices qui résulteraient de la communication
                      d’informations ou contenus inexactes ou trompeurs.
                    </p>
                    <p>
                      L’Utilisateur s’interdit également de publier tout contenu susceptibles de porter atteinte
                      aux droits, à la réputation et à l’image de {conf.site.name.toUpperCase()} et de son Site et
                      d’une manière générale
                      tout contenu qui enfreindrait les lois et règlements en vigueur.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="responsabilites">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="responsabilites">Responsabilité de la Société</h2></div>
                  <div className="mb-5">
                    <p>
                      La Société réalise ses meilleurs efforts pour assurer l’accès et le fonctionnement du Site
                      24 heures sur 24, 7 jours sur 7. Toutefois, de par la nature du fonctionnement d’Internet,
                      la Société ne saurait exclure l’interruption ou le mauvais fonctionnement du Site et des
                      Services. Aussi la Société ne saurait être tenue pour responsable d’une quelconque interruption
                      de Service, volontaire ou non, et des conséquences potentielles pour les Utilisateurs.
                    </p>
                    <p>
                      La Société ne saurait être tenue pour responsables des informations erronées, inexactes ou
                      trompeuses publiées par des Utilisateurs sur le Site.
                    </p>
                    <p>
                      La Société fait tout son possible pour s’assurer du contenu et de la validité des
                      informations sur le Site, mais ne saurait en être tenue pour responsable.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="data">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="data">Données personnelles</h2></div>
                  <div className="mb-5">
                    <p>
                      Des données à caractère personnel de l’Utilisateur font l’objet d’un traitement informatisé
                      par la Société destiné à assurer le bon fonctionnement du Site et des Services et également
                      à des fins statistiques et de prospection commerciale. La Société est seule destinataire
                      de ces données, les informations collectées ne sont ni revendues ni communiquées à des tiers.
                    </p>
                    <p>
                      Conformément à la loi "informatique et libertés" du 6 janvier 1978 modifiée, l’Utilisateur
                      bénéficie d’un droit d’accès et de rectification aux informations qui le concernent. Pour
                      exercer ce droit et obtenir communication des informations le concernant, l’Utilisateur peut
                      contacter la Société par courrier adressé à son siège social ou par email. L’Utilisateur peut
                      également s’opposer à ce traitement pour des motifs légitimes. Cette opposition peut toutefois
                      entrainer une fermeture du compte de l’Utilisateur.
                    </p>
                    <p>
                      La Société est destinataire des données à caractère personnel recueillies par l'intermédiaire
                      du Site. Elle s’engage à mettre tous les moyens en œuvre pour assurer la sécurité et la
                      confidentialité de ces données.
                    </p>
                    <p>
                      Le traitement automatisé décrit ci-dessus a fait l’objet d’une déclaration à la CNIL sous
                      le numéro {conf.site.cgu.cnil}.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="cookies">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="cookies">Cookies</h2></div>
                  <div className="mb-5">
                    <p>
                      Lors de la consultation du Site, des cookies sont susceptibles d’être déposés sur le disque dur
                      du terminal de l’Utilisateur (ordinateur, tablette, mobile, etc.). Un cookie est un fichier
                      texte,
                      qui a notamment pour but de collecter des informations relatives à la navigation et à
                      l’identification de l’Utilisateur.
                    </p>
                    <p>
                      La durée maximale de conservation des cookies implantés par la Société est de 12 mois.
                      L’Utilisateur
                      dispose toutefois de la possibilité de s’opposer à l’utilisation de ces cookies en configurant
                      de
                      manière appropriée son logiciel de navigation.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="prop-intellect-site">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="prop-intellect-site">Propriété intellectuelle du Site</h2></div>
                  <div className="mb-5">
                    <p>
                      Le Site et chacun des éléments qui le composent constituent, ensemble, une œuvre protégée par
                      les
                      lois en vigueur sur la propriété intellectuelle, dont {conf.site.name.toUpperCase()} est
                      titulaire. Aucune exploitation
                      commerciale, reproduction, représentation, utilisation, adaptation, modification, incorporation,
                      traduction, commercialisation, partielle ou intégrale de ces éléments ne pourra en être faite
                      sans
                      l'accord préalable et écrit de {conf.site.name.toUpperCase()}.
                    </p>
                    <p>
                      Ces éléments sont protégés par les lois relatives à la propriété intellectuelle et autres, et
                      notamment le droit d’auteur.
                    </p>
                    <p>
                      Toute reproduction ou représentation, intégrale ou partielle, du Site ou de l’un des éléments
                      qui
                      le composent, sans l’autorisation de la Société, est interdite et constitue une contrefaçon
                      sanctionnée par le Code de la Propriété Intellectuelle.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="prop-intellect-content">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="prop-intellect-content">Propriété intellectuelle des contenus
                    publiés</h2></div>
                  <div className="mb-5">
                    <p>
                      Tout Utilisateur qui publie des éléments de contenu (texte, images, commentaires …) sur le Site
                      garde l’entière propriété de tout ce qu’il publie.
                    </p>
                    <p>
                      En communiquant des contenus par le biais du Site, l’Utilisateur autorise
                      expressément {conf.site.name.toUpperCase()} à
                      utiliser, diffuser, héberger, stocker, reproduire, communiquer, publier, modifier, adapter,
                      traduire
                      et afficher tout ou partie du Contenu sur le Site, les réseaux sociaux ou sur tous autres
                      supports,
                      par tous moyens, à des fins d’exploitation, d’amélioration, de promotion, de marketing, de
                      publicité
                      des Services et du Site ou pour les besoins de la mise en place de partenariats. Cette
                      autorisation
                      est valable pour le monde entier et pour toute la durée de l’inscription de l’Utilisateur.
                    </p>
                    <p>
                      L’Utilisateur reconnaît que toute utilisation de son contenu effectuée
                      par {conf.site.name.toUpperCase()} préalablement à
                      sa désinscription, la suppression ou la résiliation de son compte ne pourra pas être remise en
                      cause.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="duration">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="duration">Durée, résiliation et sanctions</h2></div>
                  <div className="mb-5">
                    <p>
                      Le présent contrat est conclu pour une durée indéterminée à compter de l’acceptation des
                      Conditions
                      Générales par l’Utilisateur.
                    </p>
                    <p>
                      Dans le cas où l’Utilisateur ne respecterait pas tout ou partie des Conditions Générales ou plus
                      largement les lois et règlements en vigueur, la Société se réserve le droit de suspendre ou
                      fermer
                      le compte de l’Utilisateur immédiatement, sans préjudice de tous les dommages et intérêts
                      éventuels
                      que la Société pourrait réclamer.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="nullite">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="nullite">Nullité – Renonciation</h2></div>
                  <div className="mb-5">
                    <p>
                      Dans l’hypothèse où l’une des clauses du présent contrat serait déclarée nulle et non avenue par
                      un changement de législation, de réglementation ou par une décision de justice, cela ne saurait
                      en aucun cas affecter la validité et le respect des présentes Conditions Générales.
                    </p>
                    <p>
                      Le défaut pour la Société d’exercer les droits qui lui sont reconnus en application des
                      présentes
                      ne constitue pas une renonciation à faire valoir ses droits.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="modifs">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="modifs">Modification des conditions générales</h2></div>
                  <div className="mb-5">
                    <p>
                      La Société se réserve le droit de modifier tout ou partie des présentes Conditions Générales.
                      En cas de modification, la Société informera les Utilisateurs par tout moyen à sa disposition.
                    </p>
                    <p>
                      L’Utilisateur disposera d’un délai de 48h à compter de la date de notification pour faire part
                      de son éventuel désaccord quant aux nouvelles dispositions des Conditions Générales par tout
                      moyen.
                      A défaut de notification du désaccord dans les délais précisés ci-dessus, l’Utilisateur sera
                      réputé
                      avoir accepté les modifications apportées aux Conditions Générales.
                    </p>
                  </div>
                </div>
              </ScrollSpy>


              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="rights">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="rights">Droit applicable et juridiction compétence</h2></div>
                  <div className="mb-5">
                    <p>
                      Les présentes Conditions Générales sont soumises au droit français. Tout litige relatif à ces
                      Conditions Générales relève de la compétence exclusive des juridictions du ressort de la Cour
                      d’appel de Paris
                    </p>
                  </div>
                </div>
              </ScrollSpy>

            </div>
            <div className="col-lg-3 d-lg-block d-none">
              <MenuCheum className="cheum-cgu">
                <ScrollSpyWatch group="cgu" name="general">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#general">
                    Information générales
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="hosting">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#hosting">
                    Hébergement
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="preambule">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#preambule">
                    Préambule
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="registration">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#registration">
                    Inscription au Site
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="services">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#services">
                    Description des Services et fonctionnement du Site
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="access">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#access">
                    Accès au Site et aux Services
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="notation">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#notation">
                    Système d’évaluation et de recommandation
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="engagements">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#engagements">
                    Engagements
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="responsabiliteu">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#responsabiliteu">
                    Responsabilité de l’Utilisateur
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="responsabilites">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#responsabilites">
                    Responsabilité de la Société
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="data">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#data">
                    Données personnelles
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="cookies">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#cookies">
                    Cookies
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="prop-intellect-site">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#prop-intellect-site">
                    Propriété intellectuelle du Site
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="prop-intellect-content">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#prop-intellect-content">
                    Propriété intellectuelle des contenus publiés
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="duration">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#duration">
                    Durée, résiliation et sanctions
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="nullite">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#nullite">
                    Nullité – Renonciation
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="modifs">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#modifs">
                    Modification des conditions générales
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="rights">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#rights">
                    Droit applicable et juridiction compétence
                  </LinkScroll>
                </ScrollSpyWatch>
              </MenuCheum>
            </div>
          </div>
        </div>
      </section>
    </DefaultLayout>;
  }
}

export default withRouter(CGU);